import React from "react";
import Image from "next/image";

const Dream = () => {
  return (
    <>
      <div className="w-full pt-8 pb-10 bg-[#061A2F] px-4">
        <div className="text-center">
          <h2 className="text-[24px] relative lg:text-[40px] md:text-[38px] lg:leading-[3.5rem] md:leading-[3rem] leading-[1.8rem] text-white  font-bold text-center inline-block mx-auto px-[4px]">
            Miles US Pathway
            <Image
              src="/healthcare/home/str.svg"
              alt="CPA Recruiting firms"
              className="absolute top-0 -right-4 rotate-180"
              width={12}
              height={12}
            />
          </h2>
          <h2 className="text-[16px] lg:text-[40px] md:text-[38px] lg:leading-[3.5rem] md:leading-[3rem] leading-[1.8rem] text-white  font-bold text-center inline-block mx-auto px-[4px]">
            <span className="border-[#ca7216] border-b-2 inline-block">
              {" "}
              Making the American Dream a Reality
            </span>
          </h2>
        </div>

        <div className="">
          <Image
            src="/healthcare/home/nurs_girl.png"
            alt="STEM master's for Indian nurses in the US"
            className=""
            width={390}
            height={12}
          />
          <div className="text-white ">
            <ul className="list-disc pl-4 ml-2 font-regular text-[14px] mt-3">
              <li>
                Pursue a STEM-designated Master’s in <br /> Healthcare from top
                US universities
              </li>
              <li className="my-3">
                Receive a conditional offer letter (LOI) even <br /> before
                completing your university application
              </li>
              <li>
                Complete your degree and work in the US for 3 years on OPT with
                F-1 visa. Meanwhile your EB-3 / Green Card can get processed
              </li>
              <li className="mt-3">
                Launch your nursing career in the US with a <br />
                salary of ~$60,000
              </li>
            </ul>

            <div className="text-left mt-6">
              <div className=" flex justify-center md:justify-start">
                <div className="grp_btn flex items-center justify-start relative z-[9] w-[250px]">
                  <Image
                    priority
                    src="/images/accounting/arrow.png"
                    alt="arrow image"
                    className="new_arrow "
                    width={36}
                    height={36}
                  />
                  <a
                    href="/us-jobs-for-nurses"
                    className="new__discover_btn text-[12px] inline-block !px-10 !py-2 font-medium"
                  >
                    Know More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8">
          <Image
            src="/healthcare/home/aspir_boy.png"
            alt="US MD program for aspiring doctors in India"
            className=""
            width={390}
            height={12}
          />
          <div className="text-white">
            <ul className="list-disc pl-4 ml-2 font-regular text-[14px] mt-3">
              <li> NEET UG rank is not a mandatory requirement </li>
              <li className="my-3">
                Earn a globally recognized medical degree
              </li>
              <li>Practice in the US for 6 out of 9 years</li>
              <li className="mt-3">Earn an annual salary of INR ~2 crore</li>
            </ul>

            <div className="text-left mt-6">
              <div className=" flex justify-center md:justify-start">
                <div className="grp_btn flex items-center justify-start relative z-[9] w-[250px]">
                  <Image
                    priority
                    src="/images/accounting/arrow.png"
                    alt="arrow image"
                    className="new_arrow "
                    width={36}
                    height={36}
                  />
                  <a
                    href="/mbbs"
                    className="new__discover_btn text-[12px] inline-block !px-10 !py-2 font-medium"
                  >
                    Know More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Dream;
